import { animate, state, style, transition, trigger } from '@angular/animations'
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core'
import { FormsModule, UntypedFormGroup } from '@angular/forms'
import { Router, RouterLinkActive } from '@angular/router'
import {
  DialogRef,
  DialogService,
  KENDO_DIALOGS,
  WindowCloseResult,
  WindowComponent,
  WindowRef,
  WindowService,
} from '@progress/kendo-angular-dialog'
import * as CryptoJS from 'crypto-js'

import {
  CellTemplateDirective,
  ColumnComponent,
  FilterCellTemplateDirective,
  GridComponent,
  GridDataResult,
  GridSize,
  KENDO_GRID,
  KENDO_GRID_EXCEL_EXPORT,
  KENDO_GRID_PDF_EXPORT,
  PagerSettings,
  RowClassArgs,
  SelectableSettings,
} from '@progress/kendo-angular-grid'
import {
  CompositeFilterDescriptor,
  FilterDescriptor,
  SortDescriptor,
  process,
} from '@progress/kendo-data-query'
import { Subscription, first } from 'rxjs'
import { environment } from '../../../environments/environment'
import { DataService } from '../../@theme/services/data.service'
import { InitUserService } from '../../@theme/services/init-user.service'
import { TransactionsServices } from '../../@theme/services/transactions.service'
import { JwtHelperService } from '@auth0/angular-jwt'
import {
  CommonModule,
  DatePipe,
  NgClass,
  NgIf,
  NgSwitch,
  NgSwitchCase,
} from '@angular/common'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'

import { NgIcon, provideIcons } from '@ng-icons/core'
import {
  heroArchiveBox,
  heroBookmark,
  heroEye,
  heroFolder,
  heroMagnifyingGlass,
  heroPencil,
} from '@ng-icons/heroicons/outline'
import { heroBookmarkSolid } from '@ng-icons/heroicons/solid'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import {
  KENDO_INDICATORS,
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { SVGIcon, fileExcelIcon } from '@progress/kendo-svg-icons'
import { ToastrService } from 'ngx-toastr'
import { BtnviewsComponent } from '../../@theme/components/Buttons/btnviews/btnviews.component'
import { DropdownFilterComponent } from '../../@theme/components/dropdown-filter/dropdown-filter.component'
import { MiddlemanService } from '../../auth/services/Middleman.service'
import { PendingTransactionViewState } from '../../models/viewState.model'
import { Utilities } from '../../utilities/utilities'
import { ClientinfoComponent } from '../ClientInfo/clientinfo.component'
import { ClienttransComponent } from '../ClientInfo/clienttransactions/clienttransaction.component'
import { FilemanagerComponent } from '../FileManager/filemanager.component'
import { Filemanager2Component } from '../FileManager/filemanager2.component'
interface Item {
  text: string
  value: number
}
const helper = new JwtHelperService()
@Component({
  selector: 'gd-pending',
  templateUrl: './pending.component.html',
  styleUrls: ['./pending.component.css'],
  animations: [
    trigger('simpleFadeAnimation', [
      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),
      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [style({ opacity: 0 }), animate(600)]),
      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave', animate(600, style({ opacity: 0 }))),
    ]),
  ],
  imports: [
    CommonModule,
    DropdownFilterComponent,
    BtnviewsComponent,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    DatePipe,
    ColumnComponent,
    NgSwitch,
    NgSwitchCase,
    CellTemplateDirective,
    RouterLinkActive,
    NgClass,
    NgIf,
    FilterCellTemplateDirective,
    DropdownFilterComponent,
    FormsModule,
    WindowComponent,
    ClienttransComponent,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
    NgIcon,
  ],
  providers: [
    FilemanagerComponent,
    provideIcons({
      heroEye,
      heroMagnifyingGlass,
      heroArchiveBox,
      heroPencil,
      heroFolder,
      heroBookmark,
      heroBookmarkSolid,
    }),
  ],
  standalone: true,
})
export class PendingComponent implements OnInit, AfterViewInit, OnDestroy {
  private overlayEl!: HTMLDivElement
  public loading = false
  public fileExcelIcon: SVGIcon = fileExcelIcon
  public smallSize: GridSize = 'small'
  public defaultSize: GridSize = 'small'
  private getFilterdata = sessionStorage.getItem('blotterIdFiltered')
  public toggleText = 'Show'
  public RepNamInfo: any = []
  public autoPrint = true
  public passinggridId: any
  public passingrepfilter: any
  public type = 'numeric'
  public pendingSpinner = true
  public buttonCount = 20
  public info = true
  public pageSizes = false
  public previousNext = true
  public show = false
  public skip = 0
  public enabled = true
  public pageSize = 20
  public duration = 1200
  public ShowReviewTransaction: boolean
  public direction = 'down'
  public SuperFlag = true
  public get animate(): any {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      }
    }

    return false
  }
  public mySelection: any[] = []
  @ViewChild(GridComponent, { static: true })
  public dropdownStatusLight: Array<Item> = []
  private subscription: Subscription = new Subscription()
  public grid: GridComponent
  public multiple = false
  public allowUnsort = true
  public formGroup: UntypedFormGroup
  private viewlist: string
  private splitvalue: any
  private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  public view: GridDataResult
  public reload: any[]
  private roleing: any
  private repIdsession: number
  private listItems: any[] = []
  public selectedClientId: number
  public clientId: string
  public clientName: string
  public blotterId: string
  public blotterComment: number
  public blotId: number
  public repId: string
  public selectedValue: any
  public opened: boolean
  public windowRef: WindowRef = null
  public openup: boolean
  public showClientInfo = false
  public firstn: string
  public lastn: string
  public viewButtons: boolean
  public outquerystring: string
  public enlarge: string
  public default: string
  public selectedName: number
  public roletransition: string
  public openAccountReadOnly: boolean
  public viewallblot: string
  public ReviewTransaction: boolean
  /*   public rowCallback = (context: any) => {
  return {
    'custom-row-height': true
  };
}; */
  public sort: SortDescriptor[] = [
    {
      field: 'dateReceived',
      dir: 'desc',
    },
  ]
  public defaultFilter: CompositeFilterDescriptor = {
    logic: 'and',
    filters: [],
  }
  // Own object (not a reference to defaultFilter) so defaultFilter stays pristine for Clear Filters.
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] }
  public selectableSettings: SelectableSettings = {
    cell: true,
    mode: 'single',
    drag: false,
  }
  public group: any[] = []
  public selectedView: any
  public defaultBranchNumber = 'Filter By Branch'
  public selectedBranchNumber = this.defaultBranchNumber
  public highlightTransactionsPendingAlerts: boolean
  public clientInfoDialogRef: DialogRef
  public asPageable = (value) => Utilities.asType<PagerSettings>(value)

  public columns: any[] = []
  public rowCallback = (row: RowClassArgs) => {

    const classes: any = {
      'compact-row': true, // ✅ always apply compact styling
    }

    if (row.dataItem.alertRep) {
      // && this.highlightTransactionsPendingAlerts
      classes['highlight'] = true // ✅ preserve highlight logic
    }

    return classes
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private _nextclear: MiddlemanService,
    private router: Router,
    private toastrService: ToastrService,
    private _requestserv: MiddlemanService,
    private ur: TransactionsServices,
    private initUserService: InitUserService,
    private dialogService: DialogService,
    private windowService: WindowService,
    private dataService: DataService,
  ) {
    this.columns = this.dataService.pendingTransactionColumns.map((col) => ({
      ...col,
      // width: col.width || 160, 
    }))
    this.opened = false
    this.SuperFlag = false
    this.viewallblot = ''
    this.viewButtons = false
    this.subscription.add(
      this._nextclear.notifyredirectObservable$.subscribe((res) => {
        if (res !== null) {
          this.roleing = res.split('|')[1]
          // Ensure role is available in sessionStorage for child components
          sessionStorage.setItem('rl', this.roleing)
        }
      }),
    )
    if (this.roleing === undefined) {
      this.roleing = localStorage.getItem('rl')
      // If we got role from localStorage, also set it in sessionStorage
      if (this.roleing) {
        sessionStorage.setItem('rl', this.roleing)
      }
    }
    //  console.log('role=' + JSON.stringify(this.roleing))
    this.subscription.add(
      this.initUserService.userPreferences$.subscribe((data) => {
        if (data && Object.keys(data).length) {
          this.sort = [
            {
              field: data.pendingSortField,
              dir: data.pendingSortDir,
            },
          ]
          // this.pageSize = data.pendingRows
          this.highlightTransactionsPendingAlerts =
            data.highLightTransactionsPendingAlerts
        }
        this.subscription.add(
          this.initUserService.pendingTransactionViewState$.subscribe(
            (viewState) => {
              this.selectedView = viewState ? viewState.selectedView : 'all'
              this.filter = viewState?.filter.filters.length
                ? viewState.filter
                : this.filter
              this.sort = viewState?.sort.length ? viewState.sort : this.sort
              this.selectedBranchNumber = viewState?.filterByBranch
              // if role doesn't allow view, set to all
              if (
                this.roleing === 'INSURANCE PRINCIPAL' &&
                ['jerolyn', 'ron', 'trading'].includes(this.selectedView)
              ) {
                this.onViewChange('all')
              } else {
                this.updateView()
              }
              if (!this.listItems?.length) {
                this.getPendingTransactionsForView(this.selectedView || 'all')
              }
            },
          ),
        )
      }),
    )
  }
  public loaders = [
    {
      type: <LoaderType>'pulsing',
      themeColor: <LoaderThemeColor>'primary',
      size: <LoaderSize>'medium',
    },
    {
      type: <LoaderType>'infinite-spinner',
      themeColor: <LoaderThemeColor>'secondary',
      size: <LoaderSize>'medium',
    },
    {
      type: <LoaderType>'converging-spinner',
      themeColor: <LoaderThemeColor>'info',
      size: <LoaderSize>'medium',
    },
  ]
  public sortChange(sort: SortDescriptor[]): void {
    const removedUndefinedDir = sort.filter((s) => s.dir !== undefined)
    this.sort = removedUndefinedDir
    this.updatePendingTransactionViewState()

    if (this.roleing === 'REP') {
      this.dropdownStatusLight = [
        { text: 'Rep Processing Paperwork', value: -2 },
        { text: 'Processing Paperwork ', value: 0 },
      ]
      return
    } else {
      this.dropdownStatusLight = [
        { text: 'Rep Processing Paperwork', value: -2 },
        { text: 'Processing Paperwork ', value: 0 },
        { text: 'Submitted for Review', value: 1 },
      ]
      return
    }
  }

  public onFilterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter
    this.skip = 0
    this.updatePendingTransactionViewState()
  }

  public onPageChange(event): void {
    this.skip = event.skip
    this.updatePendingTransactionViewState()
  }

  public updatePendingTransactionViewState(): void {
    const viewState = new PendingTransactionViewState({
      selectedView: this.selectedView,
      filter: this.filter,
      sort: this.sort,
      filterByBranch: this.selectedBranchNumber,
    })

    this.initUserService.setPendingTransactionViewState(viewState)
  }

  public get hasDirection(): boolean {
    return this.type === 'slide' || this.type === 'expand'
  }
  public ngAfterViewInit(): void {
    if (this.roleing !== 'REP' || this.roleing !== 'REPDATA') {
      this.SuperFlag = true
    } else {
      this.SuperFlag = false
    }
    this.cdRef.detectChanges()
    return
  }

  ngOnInit() {
    this.columns = this.dataService.pendingTransactionColumns
    this.openAccountReadOnly = false
    if (this.roleing !== 'HOME OFFICE USER' && this.roleing !== 'REP') {
      this.viewButtons = true
      return
    }
    if (this.roleing === 'REP') {
      this.viewButtons = false
      return
    }
    if (this.roleing === 'BRANCH MANAGER') {
      this.viewButtons = false
      return
    }
    if (this.roleing === 'ADMIN') {
      this.viewButtons = true
      this.SuperFlag = false
      return
    }
    if (this.roleing === 'BRANCH MANAGER') {
      this.viewButtons = false
      this.SuperFlag = true
      return
    }
    if (this.roleing === 'BRANCH ACCESS NON MANAGER') {
      this.viewButtons = false
      this.SuperFlag = true
      return
    }
    /*  this.view.size = 'small';
    this.view.rowHeight = 28; */
    this.subscription.add(
      this._requestserv.notifyObservable$.subscribe((res) => {
        this.splitvalue = res.split('|')
        this.roleing = this.splitvalue[0]
        
        // Ensure role is available in sessionStorage for child components
        sessionStorage.setItem('rl', this.roleing)

        const paramT = CryptoJS.AES.encrypt(
          this.roleing,
          environment.securepw,
        ).toString()

        localStorage.setItem('rvarietylist', paramT)
        const storageValueReturn =
          localStorage.getItem('rvarietylist') == undefined
            ? ''
            : localStorage.getItem('rvarietylist')
        const rparam = CryptoJS.AES.decrypt(
          storageValueReturn,
          environment.securepw,
        )
        const decrypted = rparam.toString(CryptoJS.enc.Utf8)

        this.roletransition = decrypted
        if (
          this.roleing.toLocaleLowerCase() !== 'Rep'.toLocaleLowerCase() ||
          this.roleing.toLocaleLowerCase() !== 'RepData'.toLocaleLowerCase()
        ) {
          this.SuperFlag = false
        } else {
          this.SuperFlag = true
        }
      }),
    )

    const storageValueReturn =
      localStorage.getItem('rvarietylist') == undefined
        ? ''
        : localStorage.getItem('rvarietylist')
    const rparam = CryptoJS.AES.decrypt(
      storageValueReturn,
      environment.securepw,
    )
    const decrypted = rparam.toString(CryptoJS.enc.Utf8)
    this.roletransition = decrypted
    this.roleing = decodeURI(decrypted)
    
    // Ensure role is available in sessionStorage for child components
    if (this.roleing) {
      sessionStorage.setItem('rl', this.roleing)
    }
    
    setTimeout(() => {
      if (!this.listItems?.length) {
        this.getPendingTransactionsForView(this.selectedView || 'all')
      }
    })
  }

  viewClientInfo(clientId: number) {
    const clientInfoDialogRef = this.dialogService.open({
      title: 'View Client',
      content: ClientinfoComponent,
      maxHeight: '95%',
      width: '850px',
      maxWidth: '95%',
      actions: [{ text: 'Close', themeColor: 'primary' }],
    })

    const clientInfo = clientInfoDialogRef.content.instance
    clientInfo.clientId = clientId
  }

  /*
  ***********
  Progress kendo Grid
  Add on List to grid
  There is a update function based off selection.
  @Param statusTypeId
  ***********
  */
  public category(statusTypeId: number) {
    if (statusTypeId) {
      return this.dropdownStatusLight.find((x) => x.value === statusTypeId)
    } else {
      return {}
    }
  }
  handleOrderChange(selected: any, blotterId: string) {
    const param = { statusTypeId: selected, blotterstringId: blotterId }
    this.initiateupdateStatus(param)
  }
  initiateupdateStatus(param): void {
    this.subscription.add(
      this.ur.UpdatependingStats(param).subscribe((response) => {
        const datareturn = JSON.stringify(response)
        if (datareturn !== 'null') {
          this.toastrService.warning(datareturn['warning'], 'Alert')
        } else {
          const duration = 500
          this.toastrService.success('Status', 'success!')
          this.getPendingTransactionsForView(this.selectedView || 'all')
        }
      }),
    )
    this.cdRef.markForCheck()
  }

  /*
  ***********
  Progress kendo Grid Get Pending Transaction by Roles
  @Param RoleName
  ***********
  */
  getPendingTransactionsForView(view: string = null) {
    const param = {
      RoleName: this.roleing,
      RepId: this.repIdsession,
      View: view,
    }
    this.Startpendingretrievedata(param)
  }

  ngOnDestroy() {
    // Auto-clear filters when leaving the Pending page so it starts fresh on return.
    // View switches (Document/Preliminary/etc.) don't destroy this component, so they keep filters.
    const cleared = new PendingTransactionViewState({
      selectedView: this.selectedView,
      filter: { logic: 'and', filters: [] },
      sort: this.sort,
      filterByBranch: this.defaultBranchNumber,
    })
    this.initUserService.setPendingTransactionViewState(cleared)
    this.subscription.unsubscribe()
  }
  public isBookmarked(dataItem): boolean {
    return dataItem.bookm !== null
  }
  Startpendingretrievedata(param) {
    this.subscription.add(
      this.ur
        .getPendingTransactionList(param)
        .pipe(first())
        .subscribe((response) => {
          if (this.roleing === 'BRANCH ACCESS NON MANAGER') {
            this.viewButtons = false
          }
          if (this.roleing === 'BRANCH MANAGER') {
            this.viewButtons = false
          }
          if (this.roleing === 'REP') {
            this.viewButtons = false
          }
          if (this.roleing === 'ADMIN') {
            this.viewButtons = true
          }
          if (this.roleing === 'COMPLIANCE') {
            this.viewButtons = true
          }
          this.pendingSpinner = false
          this.listItems = response
          this.reload = response
          this.updateView()
          this.updateDropdowns()

          if (
            typeof this.getFilterdata !== null &&
            this.getFilterdata !== null &&
            Number(this.getFilterdata) !== 0
          ) {
            this.updateFilterForField('blotterId', Number(this.getFilterdata))
            // One-shot: drop the stored id so it isn't re-applied and Clear Filters can fully clear.
            sessionStorage.removeItem('blotterIdFiltered')
            this.getFilterdata = null
          }
          // this.isRowSelected = (e: RowArgs) =>
          //   this.mySelection.indexOf(e.dataItem.blotterId) >= 0
          this.dropdownStatusLight = [
            { text: 'Rep Processing Paperwork', value: -2 },
            { text: 'Processing Paperwork ', value: 0 },
            /*  { text: 'Submitted for Review', value: 1 }, */
          ]
        }),
    )

    // this.cdRef.detectChanges()

    //  this.ngxLoader.stop()
  }
  /*
  ***********
  Progress kendo Grid Filter by Branch
  ***********
  */
  onFilterByBranchChange(value: string) {
    if (value.toString().toLowerCase() === 'Filter By branch'.toLowerCase()) {
      //remove filter for branchNumber
      this.filter.filters = this.filter.filters.filter(
        (f: FilterDescriptor) => f.field !== 'branchNumber',
      )
      this.skip = 0
      this.updatePendingTransactionViewState()
      return
    }
    this.selectedBranchNumber = value

    this.updateFilterForField('branchNumber', value)
    return
  }

  onViewChange(view: string) {
    //    alert(JSON.stringify(view))
    this.loading = true
    this.selectedView = view
    this.updatePendingTransactionViewState()
    this.getPendingTransactionsForView(view)
  }
  /*
  ***********
  Close File Manager
  ***********
  */
  onDialogClose() {
    this.opened = false
    this.openup = false
    this.showClientInfo = false
  }
  /*
  ***********
  Account Reciept Close Popup.
  ***********
  */
  onDialogReciptClose() {
    this.openAccountReadOnly = false
  }
  close(): void {
    this.opened = false
    this.openup = false
    this._nextclear.notifyFilemanagerWhenClose(true)
  }
  /*
  ***********
  File Manager
  ***********
  */
  viewFiles(
    repId: string,
    clientName: string,
    blotterId: string,
    clientId: string,
    outquerystr: string,
  ): void {
    // If window is open, close before opening a new one
    if (this.windowRef) {
      this.windowRef.close()
    }

    this.outquerystring = outquerystr
    this.clientId = clientId
    this.clientName = clientName
    this.repId = repId
    this.blotterId = blotterId
    if (clientName.length > 0) {
      this.clientName = clientName
    }
    this.overlayEl = document.createElement('div')
    this.overlayEl.classList.add('k-overlay')
    document.body.appendChild(this.overlayEl)
    this.windowRef = this.windowService.open({
      title: 'File Manager',
      content: FilemanagerComponent,
      width: 1000,
      height: 675,
    })
    this.windowRef.result.subscribe(() => this.destroyOverlay())
    const fileManager = this.windowRef.content.instance

    fileManager.outputClientId = this.clientId
    fileManager.outputrepId = this.repId
    fileManager.clientName = this.clientName
    fileManager.outquery = this.outquerystring
    fileManager.viewallblot = this.viewallblot
    fileManager.blotterId = this.blotterId

    fileManager.getFolderFiles()

    // Sets windowRef to null when window is closed.
    // Prevents errors when opening a new file manager window after closing the previous one.
    this.windowRef.result.subscribe((result) => {
      if (result instanceof WindowCloseResult) {
        this.windowRef = null
      }
    })
  }
  private destroyOverlay(): void {
    if (this.overlayEl && document.body.contains(this.overlayEl)) {
      document.body.removeChild(this.overlayEl)
    }
  }
  /*
  ***********
  BookMark from Grid
  ***********
  */
  bookMarks(blotterId: number) {
    this.selectedName = blotterId
    const param = { blotterId: blotterId }
    this.subscription.add(
      this.ur.PostBookMarks(param).subscribe(() => {
        const duration = 1500
        this.toastrService.success('Book Mark was added', 'success!')
        this.updateView()
      }),
    )

    const itemToUpdate = this.view.data.find(
      (item) => item.blotterId === blotterId,
    )
    if (itemToUpdate) {
      itemToUpdate.bookm = blotterId
    }
    this.loading = false
  }
  /*   showToastpst(status: NbComponentStatus, message: string, duration) {
      this.toastrService.show('', message, { status, duration })
    } */
  /*
***********
BookMark Remove from Grid
***********
*/
  bookMarksremoved(blotterId: number, bookmarkId: number) {
    const param = { bookmarkId }
    this.subscription.add(
      this.ur.PostBookMarksRemove(param).subscribe(() => {
        const duration = 1500
        this.toastrService.success('Book Mark was removed', 'success!')
        this.updateView()
      }),
    )

    const itemToUpdate = this.view.data.find(
      (item) => item.blotterId === blotterId,
    )
    if (itemToUpdate) {
      itemToUpdate.bookm = null
    }
    this.loading = false
    this.cdRef.detectChanges()
  }
  public onStateChange(states): void {
    this.enlarge = states
  }
  /*
  ***********
  pass Param @BlotterId
  Query String Encrypted Param Value
  ***********
  */
  ReviewUpdateAccountForm(blotID: number) {
    const param = this.encryptProperty(blotID.toString())
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: { Rview: param },
    })
  }
  private encryptProperty(property: string): string {
    return CryptoJS.AES.encrypt(
      encodeURI(property).trim(),
      environment.securepw.trim(),
    ).toString()
  }

  /*
  ***********
  pass Param @BlotterId
  pass Param @clientId // ClientId
  pass Param @repId // RepId
  pass Param @statusTypeId // status
  pass Param @transactionId // transactiontypeId
  pass Param @productTypeId // Product Type
  Query String Encrypted Param Value
  Edit Transaction Form.
  ***********
  */
  EditTransactions(
    blotID: number,
    clientId: number,
    repId: number,
    clt: string,
    statustype: number,
    tranactionstype: number,
    producttype: number,
    reviewtransaction: boolean,
    accountformreview: boolean,
    stateid: string,
    repCodeId: number,
  ) {
    if (!repCodeId) {
      this.toastrService.error(
        'No Rep Code Id found for this transaction',
        'Error!',
      )
    }
    const blotterIdEncrypted = this.encryptProperty(blotID.toString())
    const clientIdEncrypted = this.encryptProperty(clientId.toString())
    const repIdEncrypted = this.encryptProperty(repId.toString())
    const clientNameEncrypted = this.encryptProperty(clt)
    const statusTypeIdEncrypted = this.encryptProperty(statustype.toString())
    const transactionTypeIdEncrypted = this.encryptProperty(
      tranactionstype.toString(),
    )
    const productTypeIdEncrypted = this.encryptProperty(producttype.toString())
    const stateIdEncrypted = this.encryptProperty(stateid)
    const repCodeIdEncrypted = this.encryptProperty(repCodeId?.toString())

    if (tranactionstype === 5) {
      this.EditAccount(
        clientId,
        blotterIdEncrypted,
        clientIdEncrypted,
        repIdEncrypted,
        clientNameEncrypted,
        statusTypeIdEncrypted,
        transactionTypeIdEncrypted,
        productTypeIdEncrypted,
        reviewtransaction,
        accountformreview,
        stateIdEncrypted,
        repId,
        repCodeIdEncrypted,
      )
      return
    }
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        Rview: blotterIdEncrypted,
        clientId: clientIdEncrypted,
        rId: repIdEncrypted,
        cl: clientNameEncrypted,
        EditTrans: true,
        statustype: statusTypeIdEncrypted,
        transaction: transactionTypeIdEncrypted,
        product: productTypeIdEncrypted,
        productTypeId: productTypeIdEncrypted,
        reviewtrans: reviewtransaction,
        accountformrvew: accountformreview,
        edittransactionShow: true,
        stateId: stateIdEncrypted,
        rIdunencrypt: repId,
        repCodeId: repCodeIdEncrypted,
      },
    })
    return
  }
  /*
***********
pass Param @transactionId // transactiontypeId
Edit Transaction Form.
***********
*/
  EditAccount(
    clientId: number,
    param,
    paramcli,
    paramrepencode,
    paramclientname,
    paramstatustype,
    paramtransactiontype,
    paramproducttype,
    reviewtransaction,
    accountformreview,
    paramstatetype,
    repIdunencrypt,
    repCodeIdcrypt,
  ) {
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        Rview: param,
        Cld: clientId,
        clientId: paramcli,
        rId: paramrepencode,
        cl: paramclientname,
        EditTrans: true,
        statustype: paramstatustype,
        transaction: paramtransactiontype,
        product: paramproducttype,
        reviewtrans: reviewtransaction,
        accountformrvew: accountformreview,
        edittransactionShow: true,
        stateId: paramstatetype,
        repunencrypt: repIdunencrypt,
        repCodeId: repCodeIdcrypt,
      },
    })
  }
  EditAccountviewAccountformReview(
    clientId: number,
    param,
    paramcli,
    paramrepencode,
    paramclientname,
    paramstatustype,
    paramtransactiontype,
    paramproducttype,
    reviewtransaction,
    accountformreview,
    paramstatetype,
    repIdunencrypt,
    repCodeIdcrypt,
  ) {
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        Rview: param,
        Cld: clientId,
        clientId: paramcli,
        rId: paramrepencode,
        cl: paramclientname,
        EditTrans: true,
        statustype: paramstatustype,
        transaction: paramtransactiontype,
        product: paramproducttype,
        reviewtrans: reviewtransaction,
        accountformrvew: accountformreview,
        edittransactionShow: true,
        stateId: paramstatetype,
        repunencrypt: repIdunencrypt,
        repCodeId: repCodeIdcrypt,
        paramAccReview: 'Accountreview',
      },
    })
  }
  /*
  ***********
  pass Param @BlotterId
  pass Param @clientId // ClientId
  pass Param @repId // RepId
  Query String Encrypted Param Value
  Edit Transaction Form.
  ***********
  */
  ReviewAccountTransactionsview(
    blotID: number,
    clientId: number,
    repId: number,
    clt: string,
    statustype: number,
    tranactionstype: number,
    producttype: number,
    reviewtransaction: boolean,
    accountformreview: boolean,
    statetype: string,
    repcodeId: number,
  ) {
    if (!repcodeId) {
      this.toastrService.error(
        'No Rep Code Id found for this transaction',
        'Error!',
      )
    }
    const blotterIdEncrypted = this.encryptProperty(blotID.toString())
    const clientIdEncrypted = this.encryptProperty(clientId.toString())
    const repIdEncrypted = this.encryptProperty(repId.toString())
    const clientNameEncrypted = this.encryptProperty(clt)
    const statusTypeIdEncrypted = this.encryptProperty(statustype.toString())
    const transactionTypeIdEncrypted = this.encryptProperty(
      tranactionstype.toString(),
    )
    const productTypeIdEncrypted = this.encryptProperty(producttype.toString())
    const stateIdEncrypted = this.encryptProperty(statetype)
    const repcodeIdEncrypted = this.encryptProperty(repcodeId?.toString())
    if (tranactionstype !== 5) {
      this.router.navigate(['/pages/TabsScreen/tab-views'], {
        queryParams: {
          Rview: blotterIdEncrypted,
          clientId: clientIdEncrypted,
          rId: repIdEncrypted,
          cl: clientNameEncrypted,
          ReviewShow: true,
          statustype: statusTypeIdEncrypted,
          transaction: transactionTypeIdEncrypted,
          product: productTypeIdEncrypted,
          paramAccReview: 'Accountreview',
          reviewtrans: reviewtransaction,
          accountformrvew: accountformreview,
          accountformShow: true,
          state: stateIdEncrypted,
          repCodeId: repcodeIdEncrypted,
        },
      })
      return
    }
    if (tranactionstype === 5) {
      this.router.navigate(['/pages/TabsScreen/tab-views'], {
        queryParams: {
          Rview: blotterIdEncrypted,
          clientId: clientIdEncrypted,
          rId: repIdEncrypted,
          cl: clientNameEncrypted,
          ReviewShow: true,
          statustype: statusTypeIdEncrypted,
          transaction: transactionTypeIdEncrypted,
          product: productTypeIdEncrypted,
          paramAccReview: 'Accountreview',
          reviewtrans: reviewtransaction,
          accountformrvew: accountformreview,
          accountformShow: true,
          state: stateIdEncrypted,
          repCodeId: repcodeIdEncrypted,
          repunencrypt: repId,
          Cld: clientId,
        },
      })
    }
    return
  }
  ReviewAccountReviewTransactionsview(
    blotID: number,
    clientId: number,
    repId: number,
    clt: string,
    statustype: number,
    tranactionstype: number,
    producttype: number,
    reviewtransaction: boolean,
    accountformreview: boolean,
    statetype: string,
    repCodeId: number,
  ) {
    const blotterIdEncrypted = this.encryptProperty(blotID.toString())
    const clientIdEncrypted = this.encryptProperty(clientId.toString())
    const repIdEncrypted = this.encryptProperty(repId.toString())
    const clientNameEncrypted = this.encryptProperty(clt)
    const statusTypeIdEncrypted = this.encryptProperty(statustype.toString())
    const transactionTypeIdEncrypted = this.encryptProperty(
      tranactionstype.toString(),
    )
    const productTypeIdEncrypted = this.encryptProperty(producttype.toString())
    const stateIdEncrypted = this.encryptProperty(statetype)
    const repcodeIdEncrypted = this.encryptProperty(repCodeId?.toString())

    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        Rview: blotterIdEncrypted,
        clientId: clientIdEncrypted,
        rId: repIdEncrypted,
        cl: clientNameEncrypted,
        ReviewShow: true,
        statustype: statusTypeIdEncrypted,
        transaction: transactionTypeIdEncrypted,
        product: productTypeIdEncrypted,
        paramAccReview: 'Review',
        reviewtrans: reviewtransaction,
        accountformrvew: accountformreview,
        accountformShow: true,
        state: stateIdEncrypted,
        repCodeId: repcodeIdEncrypted,
      },
    })
  }
  /*
 ***********
 pass Param @BlotterId
 pass Param @clientId // ClientId
 pass Param @repId // RepId
 Query String Encrypted Param Value
 Edit Transaction Form.
 ***********
 */
  ReviewTransactionsview(
    blotID: number,
    clientId: number,
    repId: number,
    clt: string,
    statustype: number,
    tranactionstype: number,
    producttype: number,
    reviewtransaction: boolean,
    accountformreview: boolean,
    statetype: string,
    repcodeId: number,
  ) {
    const blotterIdEncrypted = this.encryptProperty(blotID.toString())
    const clientIdEncrypted = this.encryptProperty(clientId.toString())
    const repIdEncrypted = this.encryptProperty(repId.toString())
    const clientNameEncrypted = this.encryptProperty(clt)
    const statusTypeIdEncrypted = this.encryptProperty(statustype.toString())
    const transactionTypeIdEncrypted = this.encryptProperty(
      tranactionstype.toString(),
    )
    const productTypeIdEncrypted = this.encryptProperty(producttype.toString())
    const stateIdEncrypted = this.encryptProperty(statetype)
    const repcodeIdEncrypted = this.encryptProperty(repcodeId?.toString())

    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        RviewAccount: blotterIdEncrypted,
        clientId: clientIdEncrypted,
        rId: repIdEncrypted,
        cl: clientNameEncrypted,
        ReviewShow: true,
        statustype: statusTypeIdEncrypted,
        transaction: transactionTypeIdEncrypted,
        product: productTypeIdEncrypted,
        paramAccReview: 'Transaction',
        reviewtrans: reviewtransaction,
        accountformrvew: accountformreview,
        reviewtransShow: true,
        state: stateIdEncrypted,
        repcodeId: repcodeIdEncrypted,
      },
    })
  }

  openForm(data: any) {
    this.RepNamInfo = data
    this.blotterComment = Number(data.blotterId)
    this.openAccountReadOnly = true
  }

  private updateFilterForField(
    field: string,
    value: string | number = null,
  ): void {
    // remove filter for field
    this.filter.filters = this.filter.filters.filter(
      (f: FilterDescriptor) => f.field !== field,
    )

    if (value !== null) {
      // add filter for field
      this.filter.filters.push({
        field,
        operator: typeof value === 'string' ? 'contains' : 'eq',
        value,
      })
    }

    this.skip = 0
    this.updatePendingTransactionViewState() //
  }

  clearFilters(): void {
    this.selectedBranchNumber = this.defaultBranchNumber
    this.filter = { logic: 'and', filters: [] } // fresh object — never mutate defaultFilter
    this.skip = 0
    this.updatePendingTransactionViewState()
    this.updateView()
  }

  private updateView(list: any = this.listItems): void {
    if (this.skip > list.length) {
      this.skip = 0
    }
    this.view = process(list, {
      filter: this.filter,
      sort: this.sort,
      take: this.pageSize,
      skip: this.skip,
    })
    this.loading = false
    //   this.onViewChange('all')
  }

  private updateDropdowns(): void {
    this.passinggridId = Array.from(
      new Set(this.listItems.map((b) => b.branchNumber)),
    )
    this.passingrepfilter = Array.from(
      new Set(this.listItems.map((r) => r.repName)),
    )
  }
 /*  private loadSavedViewPreference(): string | null {
    try {
      const tokenData = localStorage.getItem(this.authLocalStorageToken);
      if (!tokenData) return null;
      
      const parsed = JSON.parse(tokenData);
      const token = parsed?.token;
      if (!token) return null;
      
      const decoded = helper.decodeToken(token);
      const username = decoded?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
      
      // Get role from roleing or localStorage
      const role = this.roleing || localStorage.getItem('rl');
      
      if (username && role) {
        const storageKey = `${environment.appVersion}_pendingView_${username}_${role}`;
        return sessionStorage.getItem(storageKey);
      }
    } catch (error) {
      console.error('Error loading view preference:', error);
    }
    return null;
  } */
}
